import type { BlueprintConfig } from '@cobliteam/blueprint-react-renderer';
import { Location } from '@cobliteam/common-types';

// Extend the RouteRegistry with routes not yet published in @cobliteam/blueprint-react-renderer.
// Remove entries here once they appear in BlueprintRoutes and the package is bumped.
type ExtendedRouteRegistry = BlueprintConfig['navigation']['routeRegistry'] & {
  'cobli:camera.events': string;
};

const routeRegistry: ExtendedRouteRegistry = {
  'cobli:alerts': Location.ALERTS_TRIGGERS,
  'cobli:alerts.create': Location.ALERTS_BLUEPRINT_CREATE,
  'cobli:alerts.legacy.create': Location.ALERTS_TRIGGERS_CREATE,
  'cobli:alerts.activationHistory': Location.ALERTS_TYPE,
  'cobli:alerts.edit': Location.ALERTS_TRIGGERS_EDIT,
  'cobli:vehicle.track': Location.TRACKING,
  'cobli:camera.events': Location.CAMERA_EVENTS,
};
export { routeRegistry };
